import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Auth/Login.vue'
import Home from '@/components/Base/Home.vue'

import Editable from '@/components/Base/Editable.vue'

import draggable from 'vuedraggable'
import {DraggableTree} from 'vue-draggable-nested-tree'

import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

Vue.use(Router);


Vue.component('draggable', draggable);
Vue.component('tree', DraggableTree);
Vue.component('editable', Editable);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Login
    },
  ],
  mode: 'history',
  saveScrollPosition: true,
})



// WEBPACK FOOTER //
// ./src/router/index.js